// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1hlm4","title":"Info_title__2FCkp","links":"Info_links__3-6uK","link":"Info_link__C0gRv","logo":"Info_logo__3pMKG"};